import { useEffect } from "react";
import PersianNumber from "../../utils/PersianNumber/PersianNumber";
import { Link, NavLink, Navigate } from "react-router-dom";
import Timer from "../Timer/Timer";

import { MdOutlineCurrencyExchange } from "react-icons/md";
import { TbPlus, TbMinus } from "react-icons/tb";

const MobileListUi = ({
  roleName,
  timerStatus,
  index,
  _item,
  data,
  setData,
  resultModal,
  setResultModal,
  orderModal,
  setOrderModal,
  statePrice,
  setStatePrice,
  handlePriceChange,
  stateWeight,
  setStateWeight,
  handleWeightChange,
  stateTotal,
  setStateTotal,
  handleTotalChange,
  description,
  setDescription,
  addCommas,
  type,
  setType,
  handlePostTransaction,
  product_name,
  setProduct_name,
  setCustomeruser,
  userInfo,
  setBos,
  setIs_orderi,
  transactionId,
  //* Timer Of Order
  isTimerOn,
  setIsTimerOn,
  handleStartTimer,
  //* Update Product
  handleChangeBuyPrice,
  handleChangeSellPrice,
  //* Is Price Close
  handleChangeBuyClosePriceProduct,
  handleChangeSellClosePriceProduct,
  //* Auto Pilot
  handleChangeBuyAutoPilotProduct,
  handleChangeSellAutoPilotProduct,
}) => {
  //* Timer Of Order
  useEffect(() => {
    const storedExpiryTime = localStorage.getItem("timerExpiryTime");
    if (storedExpiryTime) {
      const remainingTime = storedExpiryTime - new Date().getTime();
      if (remainingTime > 0) {
        setIsTimerOn(true);
        setTimeout(() => {
          localStorage.removeItem("timerExpiryTime");
          setIsTimerOn(false);
        }, remainingTime);
      }
    }
  }, []);

  // تابع برای تعیین کلاس پس‌زمینه
  const getBackgroundClass = () => {
    if (_item.tag === "T") {
      return "bg-[#019682ff]/30";
    } else if (_item.name && _item.name.includes("حاضر")) {
      return "bg-[#0077ffff]/30";
    }
    return "";
  };

  return (
    <>
      <tr
        key={index}
        className={`hover:bg-boxColor w-full relative h-24 ${getBackgroundClass()}`}
      >
        {/* Number */}
        <td className="py-5 pr-3">
          <div
            className={`${
              _item.id === data.id ? "hidden" : "flex"
            } items-center text-center justify-center 
              font-medium text-sm text-gray-200
              animate__animated animate__fadeIn animate__fast`}
          >
            {index + 1}
          </div>
        </td>
        {/* Product Name */}
        <td className="py-5">
          <div
            className={`${
              _item.id === data.id ? "hidden" : "flex"
            } items-center text-center justify-center 
              font-medium text-base font-bold text-gray-200
              animate__animated animate__fadeIn animate__fast`}
          >
            {_item.name}
          </div>
        </td>
        {/* Green Prices */}
        <td className="py-5">
          <div className="flex flex-col justify-center items-center space-y-3">
            {/* Price */}
            <div className="text-green-600 flex justify-center items-center">
              {/* Increase */}

              {/* Price */}
              <div
                onClick={() => {
                  setStateWeight("");
                  setStateTotal("");
                  setDescription("");
                  setData("");
                  setType("");
                  setStatePrice(_item.buy_price);
                  setData(_item);
                  setType("buy");
                }}
                className={`${
                  _item.id === data.id ? "hidden" : "flex"
                } justify-center tracking-wide font-bold
              cursor-pointer text-base
              animate__animated animate__fadeIn animate__fast`}
              >
                {_item.buy_price === -1 ? (
                  "-"
                ) : (
                  <PersianNumber
                    value={_item.buy_price}
                    thousandSeparator=","
                  />
                )}
              </div>
              {/* Decrease */}
            </div>
            {/* Is Close Text */}
            {roleName === "ADMIN" && (
              <>
                <div
                  className={`${
                    _item?.is_buy_closed ? "text-red-600" : "text-green-600"
                  } cursor-pointer text-sm font-medium`}
                >
                  {_item?.is_buy_closed ? (
                    <p
                      onClick={() =>
                        handleChangeBuyClosePriceProduct(
                          _item?.id,
                          false,
                          _item?.periority,
                          _item?.is_sell_closed,
                          _item?.is_market_close,
                          _item.buy_auto_pilot,
                          _item.sell_auto_pilot,
                        )
                      }
                    >
                      قیمت خرید بسته
                    </p>
                  ) : (
                    <p
                      onClick={() =>
                        handleChangeBuyClosePriceProduct(
                          _item?.id,
                          true,
                          _item?.periority,
                          _item?.is_sell_closed,
                          _item?.is_market_close,
                          _item.buy_auto_pilot,
                          _item.sell_auto_pilot,
                        )
                      }
                    >
                      قیمت خرید باز
                    </p>
                  )}
                </div>
                {/* دکمه خرید خودکار/دستی */}
                <div
                  className={`${
                    _item?.buy_auto_pilot ? "text-yellow-600" : "text-gray-200"
                  } cursor-pointer text-sm font-medium`}
                >
                  {_item?.buy_auto_pilot ? (
                    <p
                      onClick={() =>
                        handleChangeBuyAutoPilotProduct(
                          _item?.id,
                          _item?.is_buy_closed,
                          _item?.periority,
                          _item?.is_sell_closed,
                          _item?.is_market_close,
                          false,
                          _item?.sell_auto_pilot,
                        )
                      }
                    >
                      خرید خودکار
                    </p>
                  ) : (
                    <p
                      onClick={() =>
                        handleChangeBuyAutoPilotProduct(
                          _item?.id,
                          _item?.is_buy_closed,
                          _item?.periority,
                          _item?.is_sell_closed,
                          _item?.is_market_close,
                          true,
                          _item?.sell_auto_pilot,
                        )
                      }
                    >
                      خرید دستی
                    </p>
                  )}
                </div>
              </>
            )}
          </div>
        </td>
        {/* Red Prices */}
        <td className="py-5">
          <div className="flex flex-col justify-center items-center space-y-3">
            {/* Price */}
            <div className="text-red-600 flex justify-center items-center">
              {/* Price */}
              <div
                onClick={() => {
                  setStateWeight("");
                  setStateTotal("");
                  setDescription("");
                  setData("");
                  setType("");
                  setStatePrice(_item.sell_price);
                  setData(_item);
                  setType("sell");
                }}
                className={`${
                  _item.id === data.id ? "hidden" : "flex"
                } justify-center tracking-wide font-bold
                cursor-pointer text-base
                animate__animated animate__fadeIn animate__fast`}
              >
                {_item.sell_price === -1 ? (
                  "-"
                ) : (
                  <PersianNumber
                    value={_item.sell_price}
                    thousandSeparator=","
                  />
                )}
              </div>
            </div>
            {/* Is Close Text */}
            {roleName === "ADMIN" && (
              <>
                <div
                  className={`${
                    _item?.is_sell_closed ? "text-red-600" : "text-green-600"
                  } cursor-pointer text-sm font-medium`}
                >
                  {_item?.is_sell_closed ? (
                    <p
                      onClick={() =>
                        handleChangeSellClosePriceProduct(
                          _item?.id,
                          false,
                          _item?.periority,
                          _item?.is_buy_closed,
                          _item?.is_market_close,
                          _item.buy_auto_pilot,
                          _item.sell_auto_pilot,
                        )
                      }
                    >
                      قیمت فروش بسته
                    </p>
                  ) : (
                    <p
                      onClick={() =>
                        handleChangeSellClosePriceProduct(
                          _item?.id,
                          true,
                          _item?.periority,
                          _item?.is_buy_closed,
                          _item?.is_market_close,
                          _item.buy_auto_pilot,
                          _item.sell_auto_pilot,
                        )
                      }
                    >
                      قیمت فروش باز
                    </p>
                  )}
                </div>
                {/* دکمه فروش خودکار/دستی */}
                <div
                  className={`${
                    _item?.sell_auto_pilot ? "text-yellow-600" : "text-gray-200"
                  } cursor-pointer text-sm font-medium`}
                >
                  {_item?.sell_auto_pilot ? (
                    <p
                      onClick={() =>
                        handleChangeSellAutoPilotProduct(
                          _item?.id,
                          _item?.is_buy_closed,
                          _item?.periority,
                          _item?.is_sell_closed,
                          _item?.is_market_close,
                          _item?.buy_auto_pilot,
                          false,
                        )
                      }
                    >
                      فروش خودکار
                    </p>
                  ) : (
                    <p
                      onClick={() =>
                        handleChangeSellAutoPilotProduct(
                          _item?.id,
                          _item?.is_buy_closed,
                          _item?.periority,
                          _item?.is_sell_closed,
                          _item?.is_market_close,
                          _item?.buy_auto_pilot,
                          true,
                        )
                      }
                    >
                      فروش دستی
                    </p>
                  )}
                </div>
              </>
            )}
          </div>
        </td>
        {/* Last Update */}
        <td className="py-5">
          <div
            className={`${
              _item.id === data.id ? "hidden" : "flex"
            } justify-center text-gray-200 text-sm font-medium
            animate__animated animate__fadeIn animate__fast`}
          >
            {/* {formatToPersianDate(_item.last_update_time_ago)} */}
            {_item.last_update_time_ago}
          </div>
        </td>
        {/* Modal */}
        {_item?.id === data?.id && (
          <>
            <div
              className="flex bg-[#101632] bg-opacity-0 fixed lg:mr-40
            inset-0 items-center w-full z-50 mr-auto h-screen
            animate__animated animate__fadeIn animate__fast"
            >
              <div
                className="flex flex-col -mt-5 w-11/12 sm:w-5/6
                lg:w-12/12 max-w-2xl mx-auto rounded-lg 
              border-2 border-boxColor"
              >
                {/* Order Modal */}
                {orderModal && (
                  <>
                    {/* Title */}
                    <div
                      className="flex justify-center items-center
                   w-full p-6 bg-[#101632]"
                    >
                      <p className="text-lg font-bold text-gray-200">
                        سفارش{" "}
                        <span
                          className={`${
                            type === "buy" ? "text-green-700" : "text-red-700"
                          } font-bold`}
                        >
                          {type === "buy" ? "خرید" : "فروش"}
                        </span>{" "}
                        برای " {_item?.name} "
                      </p>
                    </div>
                    {/* Confirmation Of Order */}
                    <div
                      className="grid grid-cols-2 gap-y-5 justify-items-center pb-5
                      items-center w-full bg-[#101632] text-gray-200 text-lg"
                    >
                      {/* Price */}
                      {statePrice ? (
                        <span className="flex flex-col items-center space-y-2">
                          <span className="font-semibold">
                            {_item.tag === "S" ? "قیمت" : "مظنه"}{" "}
                          </span>
                          <span className="font-bold">
                            <PersianNumber
                              value={statePrice}
                              thousandSeparator=","
                            />
                          </span>
                        </span>
                      ) : (
                        <span className="flex flex-col items-center space-y-2">
                          <span className="font-semibold">
                            {_item.tag === "S" ? "قیمت" : "مظنه"}
                          </span>
                          <span className="font-bold">-</span>
                        </span>
                      )}
                      {/* Weight */}
                      {stateWeight ? (
                        <span className="flex flex-col items-center space-y-2">
                          <span className="font-semibold">
                            {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"}
                          </span>
                          <span className="font-bold">
                            <PersianNumber
                              value={stateWeight}
                              thousandSeparator=","
                            />
                          </span>
                        </span>
                      ) : (
                        <span className="flex flex-col items-center space-y-2">
                          <span className="font-semibold">
                            {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"}
                          </span>
                          <span className="font-bold">-</span>
                        </span>
                      )}
                      {/* Total */}
                      {stateTotal ? (
                        <span className="flex flex-col items-center space-y-2">
                          <span className="font-semibold">جمع کل</span>
                          <span className="font-bold">
                            <PersianNumber
                              value={stateTotal}
                              thousandSeparator=","
                            />
                          </span>
                        </span>
                      ) : (
                        <span className="flex flex-col items-center space-y-2">
                          <span className="font-semibold">جمع کل</span>
                          <span className="font-bold">-</span>
                        </span>
                      )}
                      {/* Description */}
                      {description ? (
                        <span
                          className="flex flex-col items-center
                          w-40 overflow-hidden text-ellipsis whitespace-nowrap space-y-2"
                        >
                          <span className="font-semibold">توضیحات</span>
                          <span className="font-bold">{description}</span>
                        </span>
                      ) : (
                        <span className="flex flex-col items-center space-y-2">
                          <span className="font-semibold">توضیحات</span>
                          <span className="font-bold">-</span>
                        </span>
                      )}
                    </div>
                    <span className="border-b-2 border-boxColor" />

                    {/* Result Modal */}
                    {!resultModal ? (
                      // *Inputs - Button
                      <>
                        <div className="w-full px-6 py-6 bg-[#101632] relative">
                          <form onSubmit={handlePostTransaction}>
                            {/* Inputs */}
                            <div className="flex flex-col w-full">
                              {/* Order Icon */}
                              {type === "buy" && (
                                <>
                                  {_item.buy_price !== statePrice && (
                                    <span
                                      className="absolute px-2 py-1 rounded-full top-3
                              left-2 flex items-center text-slate-300"
                                    >
                                      <div className="group flex relative">
                                        <MdOutlineCurrencyExchange
                                          size={22}
                                          className="animate-spin-slow"
                                        />
                                        <span
                                          className="group-hover:opacity-0 transition-opacity 
                                  px-1 text-base text-slate-300 rounded-md absolute left-1/2 
                                  -translate-x-1/2 translate-y-full opacity-0 m-1 mx-auto"
                                        >
                                          اردری
                                        </span>
                                      </div>
                                    </span>
                                  )}
                                </>
                              )}
                              {type === "sell" && (
                                <>
                                  {_item.sell_price !== statePrice && (
                                    <span
                                      className="absolute px-2 py-1 rounded-full top-3
                              left-2 flex items-center text-slate-300"
                                    >
                                      <div className="group flex relative">
                                        <MdOutlineCurrencyExchange
                                          size={22}
                                          className="animate-spin-slow"
                                        />
                                        <span
                                          className="group-hover:opacity-0 transition-opacity 
                                  px-1 text-base text-slate-300 rounded-md absolute left-1/2 
                                  -translate-x-1/2 translate-y-full opacity-0 m-1 mx-auto"
                                        >
                                          اردری
                                        </span>
                                      </div>
                                    </span>
                                  )}
                                </>
                              )}

                              <span>
                                {/* Price */}
                                <span className="w-full">
                                  <label
                                    htmlFor="price"
                                    className="block mb-3 mr-2.5 text-base font-medium text-gray-200"
                                  >
                                    {_item.tag === "S" ? "قیمت" : "مظنه"}
                                  </label>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    name="price"
                                    value={
                                      statePrice === -1
                                        ? ""
                                        : statePrice === ""
                                          ? statePrice + statePrice
                                          : addCommas(statePrice)
                                    }
                                    onChange={(e) => {
                                      handlePriceChange(_item, e);
                                    }}
                                    className={`p-3 mb-3 bg-[#101632] border-2
                     border-slate-600 w-full rounded-md focus:right-0 
                     focus:outline-none tracking-wide text-gray-200 text-lg
                     ${
                       type === "buy"
                         ? "focus:border-green-600 focus:text-green-600"
                         : "focus:border-red-600 focus:text-red-600"
                     }
                   `}
                                  />
                                </span>
                                {/* Weight */}
                                <span className="w-full">
                                  <label
                                    htmlFor="weight"
                                    className="block mb-3 mr-2.5 text-base font-medium text-gray-200"
                                  >
                                    {_item.tag === "S"
                                      ? "تعداد"
                                      : "مقدار (گرم)"}
                                  </label>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    name="weight"
                                    value={stateWeight}
                                    onChange={(e) => {
                                      handleWeightChange(_item, e);
                                    }}
                                    className={`p-3 mb-3 bg-[#101632] border-2
                     border-slate-600 w-full rounded-md focus:right-0 
                     focus:outline-none tracking-wide text-gray-200 text-lg
                   ${
                     type === "buy"
                       ? "focus:border-green-600 focus:text-green-600"
                       : "focus:border-red-600 focus:text-red-600"
                   }`}
                                  />
                                </span>
                                {/* Total */}
                                <span className="w-full">
                                  <label
                                    htmlFor="total"
                                    className="block mb-3 mr-2.5 text-base font-medium text-gray-200"
                                  >
                                    جمع کل
                                  </label>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    name="total"
                                    value={addCommas(stateTotal)}
                                    onChange={(e) => {
                                      handleTotalChange(_item, e);
                                    }}
                                    className={`p-3 mb-3 bg-[#101632] border-2
                      border-slate-600 w-full rounded-md
                      focus:right-0 focus:outline-none tracking-wide
                     text-gray-200 text-lg
                     ${
                       type === "buy"
                         ? "focus:border-green-600 focus:text-green-600"
                         : "focus:border-red-600 focus:text-red-600"
                     }`}
                                  />
                                </span>
                                {/* Description */}
                                <span className="w-full">
                                  <label
                                    htmlFor="description"
                                    className="block mb-3 mr-2.5 text-base font-medium text-gray-200"
                                  >
                                    توضیحات
                                  </label>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    name="description"
                                    value={description ? description : ""}
                                    onChange={(e) =>
                                      setDescription(e.target.value)
                                    }
                                    className={`p-3 mb-3 bg-[#101632] border-2
                      border-slate-600 w-full rounded-md
                      focus:right-0 focus:outline-none tracking-wide
                     text-gray-200 text-lg
                     ${
                       type === "buy"
                         ? "focus:border-green-600 focus:text-green-600"
                         : "focus:border-red-600 focus:text-red-600"
                     }`}
                                  />
                                </span>
                                {/* Other Items To Send */}
                                <div>
                                  {setProduct_name(_item.name)}
                                  {setCustomeruser(userInfo[0]?.id)}
                                  {type === "buy" ? setBos("B") : setBos("S")}
                                  {setIs_orderi(
                                    _item.buy_price !== statePrice
                                      ? true
                                      : false,
                                  )}
                                </div>
                              </span>
                            </div>
                            {/* Button */}
                            <span className="flex justify-center w-full mt-6">
                              <button
                                className="text-slate-200 text-lg font-medium tracking-wider mx-4"
                                onClick={() => {
                                  setStatePrice("");
                                  setStateWeight("");
                                  setStateTotal("");
                                  setDescription("");
                                  setData("");
                                  setType("");
                                  setOrderModal(true);
                                  setResultModal(false);
                                }}
                              >
                                لغو
                              </button>
                              {timerStatus ? (
                                <Timer durationInSeconds={60} />
                              ) : (
                                <>
                                  <button
                                    onClick={handleStartTimer}
                                    // type="submit"
                                    className={`${
                                      type === "buy"
                                        ? "bg-green-500 hover:bg-green-700"
                                        : "bg-red-500 hover:bg-red-700"
                                    } rounded-full px-4 py-2 mx-2
                        tracking-wider text-lg font-medium text-gray-200
                        transition-all duration-100 ease-linear
                        hover:transition-all hover:duration-100 hover:ease-linear`}
                                  >
                                    {type === "buy" ? "خرید" : "فروش"}
                                  </button>
                                </>
                              )}
                            </span>
                          </form>
                        </div>
                      </>
                    ) : (
                      //*  Result Modal
                      <>
                        <div className="w-full px-7 py-6 bg-[#101632]">
                          {transactionId ? (
                            <>
                              <div
                                className="flex flex-col justify-between items-center w-full h-full space-y-6
                              text-slate-300 text-lg animate__animated animate__fadeIn animate__fast"
                              >
                                <span className="flex flex-col justify-around items-center w-full space-y-3">
                                  {/* Text */}
                                  <span
                                    className={`${
                                      type === "buy"
                                        ? "text-green-600"
                                        : "text-red-600"
                                    }
                                font-bold text-center tracking-wide text-xl`}
                                  >
                                    {type === "buy" ? "خرید " : "فروش "}
                                    <span className="text-gray-200 text-lg">
                                      شما ثبت گردید به صفحه معاملات رجوع کنید
                                    </span>
                                  </span>
                                  {/* Transaction Id */}
                                  <span className="font-medium flex tracking-wider text-zinc-300 text-lg">
                                    <span>شماره سفارش : </span>
                                    <span>#{transactionId}</span>
                                  </span>
                                </span>

                                {/* Timer */}
                                {timerStatus && (
                                  <Timer durationInSeconds={60} />
                                )}

                                {/* Button */}
                                <span className="w-3/12 flex justify-center ">
                                  <NavLink to="/Public/Live-Transactions">
                                    <button
                                      onClick={() => {
                                        setStatePrice("");
                                        setStateWeight("");
                                        setStateTotal("");
                                        setData("");
                                        setType("");
                                        setOrderModal(true);
                                        setResultModal(false);
                                      }}
                                      className="bg-yellow-500 hover:bg-green-700 text-slate-700 rounded-full px-5 py-2 transition-colors text-lg font-medium"
                                    >
                                      معاملات جاری
                                    </button>
                                  </NavLink>
                                  <button
                                    onClick={() => {
                                      setStatePrice("");
                                      setStateWeight("");
                                      setStateTotal("");
                                      setData("");
                                      setType("");
                                      setOrderModal(true);
                                      setResultModal(false);
                                    }}
                                    className="rounded-full px-5 py-2 mx-2
                                tracking-wider text-lg font-medium text-gray-200 
                                bg-green-500 hover:bg-green-700
                                transition-all duration-100 ease-linear
                                hover:transition-all hover:duration-100 hover:ease-linear"
                                  >
                                    بستن
                                  </button>
                                </span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                className="flex flex-col justify-center items-center w-full h-full
                          space-y-6 animate__animated animate__fadeIn animate__fast"
                              >
                                <span
                                  className="flex items-center justify-center 
                            w-full text-slate-700 text-lg font-bold text-center"
                                >
                                  <span className="flex flex-col justify-around items-center w-full space-y-3">
                                    {/* Text */}
                                    <span
                                      className={`${
                                        type === "buy"
                                          ? "text-green-600"
                                          : "text-red-600"
                                      }
                                font-bold text-center tracking-wide text-xl`}
                                    >
                                      {type === "buy" ? "خرید " : "فروش "}
                                      <span className="text-gray-200 text-lg">
                                        شما ثبت گردید به صفحه معاملات رجوع کنید
                                      </span>
                                    </span>
                                    {/* Transaction Id */}
                                    <span className="font-medium flex tracking-wider text-zinc-300 text-lg">
                                      <span>شماره سفارش : </span>
                                      <span>#{transactionId}</span>
                                    </span>
                                  </span>
                                </span>
                                <span className="w-3/12 flex justify-center ">
                                  <NavLink to="/Public/Live-Transactions">
                                    <button
                                      onClick={() => {
                                        setStatePrice("");
                                        setStateWeight("");
                                        setStateTotal("");
                                        setData("");
                                        setType("");
                                        setOrderModal(true);
                                        setResultModal(false);
                                      }}
                                      className="bg-yellow-500 hover:bg-green-700 text-slate-700 rounded-full px-5 py-2 transition-colors text-lg font-medium"
                                    >
                                      معاملات جاری
                                    </button>
                                  </NavLink>
                                  <button
                                    onClick={() => {
                                      setStatePrice("");
                                      setStateWeight("");
                                      setStateTotal("");
                                      setData("");
                                      setType("");
                                      setOrderModal(true);
                                      setResultModal(false);
                                    }}
                                    className="rounded-full px-5 py-2 mx-2
                                tracking-wider text-lg font-medium text-gray-200 
                                bg-green-500 hover:bg-green-700
                                transition-all duration-100 ease-linear
                                hover:transition-all hover:duration-100 hover:ease-linear"
                                  >
                                    بستن
                                  </button>
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </tr>
    </>
  );
};

export default MobileListUi;
